import React from 'react';
import classnames from 'classnames';
import classes from './SelectConnection.module.scss';
import { TextField } from 'new/elements/TextField';
import { Search } from '@mui/icons-material';

interface SearchBarProps {
  children?: React.ReactNode;
  isCentered?: boolean;
  onSearchChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> &
    React.FormEventHandler<HTMLLabelElement>;
}

export const SearchBar = (props: SearchBarProps) => {
  return (
    <div
      className={classnames(classes.searchBarContainer, {
        [classes.searchBarContainerCentered]: props.isCentered,
      })}
    >
      <div className={classes.searchField}>
        <TextField
          startAdornment={<Search />}
          placeholder="Search connectors…"
          inputProps={{ 'aria-label': 'Search connectors' }}
          onChange={props.onSearchChange}
          fullWidth
        />
      </div>
      {props.children}
    </div>
  );
};
